/**
 * Les 197 pays du catalogue LogiFlow (`accounts/data/pays.py`), en ISO 3166-1
 * alpha-2. Les noms ne sont pas ici : le navigateur les donne dans la langue
 * du visiteur (`Intl.DisplayNames`), une seule liste sert au français et à
 * l'anglais, et elle n'a pas à être maintenue à la main.
 */
export const CODES_PAYS = "AD,AE,AF,AG,AL,AM,AO,AR,AT,AU,AZ,BA,BB,BD,BE,BF,BG,BH,BI,BJ,BN,BO,BR,BS,BT,BW,BY,BZ,CA,CD,CF,CG,CH,CI,CL,CM,CN,CO,CR,CU,CV,CY,CZ,DE,DJ,DK,DM,DO,DZ,EC,EE,EG,ER,ES,ET,FI,FJ,FM,FR,GA,GB,GD,GE,GH,GM,GN,GQ,GR,GT,GW,GY,HN,HR,HT,HU,ID,IE,IL,IN,IQ,IR,IS,IT,JM,JO,JP,KE,KG,KH,KI,KM,KN,KP,KR,KW,KZ,LA,LB,LC,LI,LK,LR,LS,LT,LU,LV,LY,MA,MC,MD,ME,MG,MH,MK,ML,MM,MN,MR,MT,MU,MV,MW,MX,MY,MZ,NA,NE,NG,NI,NL,NO,NP,NR,NZ,OM,PA,PE,PG,PH,PK,PL,PS,PT,PW,PY,QA,RO,RS,RU,RW,SA,SB,SC,SD,SE,SG,SI,SK,SL,SM,SN,SO,SR,SS,ST,SV,SY,SZ,TD,TG,TH,TJ,TL,TM,TN,TO,TR,TT,TV,TW,TZ,UA,UG,US,UY,UZ,VA,VC,VE,VN,VU,WS,XK,YE,ZA,ZM,ZW".split(",");

/** Déjà desservis : inutile de les proposer dans « Ton pays n'y est pas ? ». */
export const PAYS_DESSERVIS = new Set(["CA", "GN", "CI", "BF"]);

/** Ce que `Intl.DisplayNames` ne connaît pas partout. */
const NOMS_DE_SECOURS: Record<string, Record<string, string>> = {
  XK: { fr: "Kosovo", en: "Kosovo" },
};

/**
 * Les pays à proposer, nommés dans la langue donnée et triés comme elle trie.
 * Par défaut sans ceux déjà desservis (« Demande ton pays ») ; `tous` les
 * garde, pour qui doit pouvoir choisir n'importe quel pays.
 */
export function listePays(locale: string, { tous = false }: { tous?: boolean } = {}): { code: string; nom: string }[] {
  let noms: Intl.DisplayNames | null = null;
  try {
    noms = new Intl.DisplayNames([locale], { type: "region" });
  } catch {
    noms = null;
  }
  return CODES_PAYS
    .filter((code) => tous || !PAYS_DESSERVIS.has(code))
    .map((code) => {
      let nom: string | undefined;
      try {
        nom = noms?.of(code);
      } catch {
        nom = undefined;
      }
      if (!nom || nom === code) nom = NOMS_DE_SECOURS[code]?.[locale] ?? NOMS_DE_SECOURS[code]?.fr ?? code;
      return { code, nom };
    })
    .sort((a, b) => a.nom.localeCompare(b.nom, locale));
}
